import React from "react";
import { useHubspotForm } from '@aaronhayes/react-use-hubspot-form';
import Loader from "../../Loader/loader";

export const EmailUsForm = () => {
    const { loaded, error, formCreated } = useHubspotForm({
        portalId: '22438271',
        formId: '615196be-2a25-4699-abba-a37c9c33255c',
        target: '#email-us-form'
    });

    return (
        <div className="mt-4">
            {(loaded && formCreated) ? <div id="email-us-form"></div> : <Loader />}
        </div>
    );
};